const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMafia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "36px",
    height: "36px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#ffffff",
    d: "M19.476 6.539q6.376 -0.069 12.867 0.14 0.274 -0.03 0.351 -0.282 0.486 -0.314 0.985 -0.633 0.67 -0.107 1.196 0.351 0.532 0.787 1.054 1.547v2.11q-0.172 0.197 -0.351 0.422l-0.14 2.25a1.62 1.62 0 0 1 -0.633 0.492 615.857 615.857 0 0 1 -14.485 0.492 2.186 2.186 0 0 0 -0.914 0.14 9 9 0 0 1 -1.054 0.843q-2.182 -1.556 -3.446 0.843 -0.288 1.886 1.476 2.532v0.422q-1.71 0.13 -3.304 -0.282 -0.208 0.278 -0.492 0.422 -1.147 0.553 -1.476 1.828a664.714 664.714 0 0 1 -2.742 9.14q0.404 0.332 0.422 0.843a24.171 24.171 0 0 1 -5.343 -0.633q-0.897 -0.129 -0.422 -0.914h-0.563q0.231 -0.189 0 -0.351 -0.573 -0.377 -1.196 -0.071 -0.399 -0.06 -0.563 -0.422l-0.14 0.14a1.543 1.543 0 0 0 -0.351 -0.422 1.8 1.8 0 0 1 0.563 -0.351 1.029 1.029 0 0 1 -0.282 -0.351q0.275 -0.288 0 -0.563a1216.286 1216.286 0 0 1 3.515 -9.774q-0.53 -2.907 -3.515 -2.39 -0.557 -0.638 0.14 -1.196a19.286 19.286 0 0 1 2.39 -1.125q0.275 -0.298 0.351 -0.703 0.188 -1.08 -0.14 -2.11a34.714 34.714 0 0 1 -1.616 -1.333q0.217 -0.359 0.633 -0.351 0.854 0.343 1.758 0.211 0.687 -1.223 2.11 -1.265 0.774 -0.985 1.547 0 3.012 0.307 6.117 0.071a1.35 1.35 0 0 1 0.633 0.211q2.53 0.105 5.063 0.071"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.339
    },
    fill: "#ffffff",
    d: "M32.696 6.399q-0.077 0.252 -0.351 0.282a298.286 298.286 0 0 0 -12.867 -0.14 311.143 311.143 0 0 1 13.218 -0.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ffffff",
    d: "M20.321 13.429a7.714 7.714 0 0 0 -0.774 0.985 57.857 57.857 0 0 1 -0.282 2.532q-0.599 1.161 -1.899 1.336 -2.39 0.105 -4.782 0.071 0.284 -0.145 0.492 -0.422 1.594 0.41 3.304 0.282v-0.422q2.34 0.015 2.39 -2.321a6.043 6.043 0 0 0 -0.422 -1.054 9 9 0 0 0 1.054 -0.843 2.186 2.186 0 0 1 0.914 -0.14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#ffffff",
    d: "M0.492 26.226q0.275 0.275 0 0.563a1.029 1.029 0 0 0 0.282 0.351 1.8 1.8 0 0 0 -0.563 0.351 1.543 1.543 0 0 1 0.351 0.422l0.14 -0.14q0.163 0.361 0.563 0.422 0.622 -0.306 1.196 0.071 0.231 0.162 0 0.351a12.214 12.214 0 0 1 -2.532 -0.703v-0.282a12.857 12.857 0 0 1 0.563 -1.407"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMafia);
export default __webpack_public_path__ + "static/media/mafia.038ee26575da0e031bcb09ba44c8d2f8.svg";
export { ForwardRef as ReactComponent };